/**
 * The sub-region and species line on a `WorkshopList` card.
 *
 * The sub-region is tinted with its own accent so the line agrees with the
 * date block beside it. Visibility comes from the row's resolved switches,
 * not raw presence — a caller can force either off even when the data is
 * there.
 */
import type { WorkshopListSize } from './workshopListSizes';
import { WORKSHOP_LIST_SIZES } from './workshopListSizes';

export interface WorkshopListMetaProps {
  subregionLabel?: string | null;
  species: string | null;
  color: string;
  showSubregion: boolean;
  showSpecies: boolean;
  size?: WorkshopListSize;
}

export function WorkshopListMeta({
  subregionLabel,
  species,
  color,
  showSubregion,
  showSpecies,
  size = 'md',
}: WorkshopListMetaProps) {
  if (!showSubregion && !showSpecies) return null;
  return (
    <div
      style={{
        fontSize: WORKSHOP_LIST_SIZES[size].meta,
        marginTop: 2,
        fontWeight: 600,
        color: 'var(--nb-muted)',
        minWidth: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      }}
    >
      {showSubregion && <span style={{ color }}>{subregionLabel}</span>}
      {showSubregion && showSpecies && <span style={{ opacity: 0.5 }}> · </span>}
      {showSpecies && <span>{species}</span>}
    </div>
  );
}
